import './IntroSection2.css';
import andImg from '../assets/and.png';
import Space from './Space';

const IntroSection2 = () => {
    return (
        <div className="section intro-section">
            <div className="text-container">
                <h1 className="w300 cLight">Eric Sucitra</h1>
                <p className="w700 cLight mini space-out">THE SON OF</p>
                <p className="w300 cLight">Mr. Teoh Liam Peng and Mrs. Kho Chun Fung</p>
            </div>

            <img src={andImg} alt="and" className="and-image" width="100%" />

            <div className="text-container">
                <h1 className="w300 cLight">Jessyca Putri Kartiadi</h1>
                <p className="w700 cLight mini space-out">THE DAUGHTER OF</p>
                <p className="w300 cLight">Mr. Lim Gap Weng and Mrs. Tan Ai Huang</p>
            </div>
            <Space s={128} />
        </div>
    );
};

export default IntroSection2;
